
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import NodeFormMixin from '../forms/NodeFormMixin';
import { ResolveController } from 'rt/UIApiControllers/UI/Smart/ResolveController';

@Component({
  name: 'EndSummary',
})
export default class EndSummary extends NodeFormMixin {
  get alertType(): string {
    if (!this.data.action.message) {
      return 'warning';
    }
    switch (this.type.name) {
      case 'Ends.EndFailure':
        return 'error';
      case 'Ends.EndSuccess':
        return 'success';
    }
    return 'info';
  }
}
